import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
  getCurrentRepoWorkspaceSlug,
  getIsPipelinesEnabledLoadingState,
  getCurrentRepositoryFullSlug,
} from 'src/selectors/repository-selectors';
import { getCurrentUser } from 'src/selectors/user-selectors';
import { getWorkspacePlanRequestStatus } from 'src/selectors/workspace-selectors';

import {
  fetchIsPipelinesEnabled,
  fetchWorkspacePlan,
} from '../actions/fetch-repository-details';
import { PipelinesEnabledLoadingState } from '../reducers/details';

export const useRepositoryNavigationEffects = (): void => {
  const dispatch = useDispatch();
  const currentUser = useSelector(getCurrentUser);
  const isPipelinesEnabledLoadingState = useSelector(
    getIsPipelinesEnabledLoadingState
  );
  const workspaceSlug = useSelector(getCurrentRepoWorkspaceSlug);
  const repositorySlug = useSelector(getCurrentRepositoryFullSlug);
  const { isFetchWorkspacePlanLoading } = useSelector(
    getWorkspacePlanRequestStatus
  );

  useEffect(() => {
    if (
      currentUser &&
      repositorySlug &&
      isPipelinesEnabledLoadingState === PipelinesEnabledLoadingState.NotLoaded
    ) {
      dispatch(fetchIsPipelinesEnabled());
    }
  }, [dispatch, currentUser, isPipelinesEnabledLoadingState, repositorySlug]);

  useEffect(() => {
    if (workspaceSlug && isFetchWorkspacePlanLoading) {
      dispatch(fetchWorkspacePlan(workspaceSlug));
    }
  }, [dispatch, isFetchWorkspacePlanLoading, workspaceSlug]);
};
